import { Injectable } from '@angular/core';
import { BrugerRolle } from '@features/brugere/bruger-roller/bruger-rolle.model';
import { RestApi } from '@core/api/rest.api';

@Injectable({
  providedIn: 'root'
})
export class BrugerRolleApi extends RestApi<BrugerRolle> {
  override endpoint = '/v2/brugerroller';

}
